<template>
    <div id="appIndex">
        <loadingS v-if='loading'></loadingS>
        <template v-else>
            <div class="appIndex_banner">
                <div class="back_icon"
                     @click="goBack"></div>
            </div>
            <div class="subject_list">
                <!-- 小学语文期末测试一 -->
                <div v-if="yw1.length"
                        class="item">
                    <div class="list_title"><span>语文</span>领跑新学期试卷一</div>
                    <div class="unit_list">
                        <div class="list_item"
                                v-for="(item,index) in yw1"
                                :key="index">
                            <div class="unit_name ellipsis">{{item.unit_name}}</div>
                            <router-link class="preview_btn"
                                            :to="'/chinese/inspect/preview/task/'+item.paper_id+'?hd_type='+hd_type">预览</router-link>
                            <button class="share_btn"
                                    @click="share(item)">分享给学生</button>
                            <button class="go_detail"
                                    @click="goDetail(item)">查看完成情况</button>
                        </div>
                    </div>
                </div>
                <div v-if="yw2.length"
                        class="item">
                    <div class="list_title"><span>语文</span>领跑新学期试卷二</div>
                    <div class="unit_list">
                        <div class="list_item"
                                v-for="(item,index) in yw2"
                                :key="index">
                            <div class="unit_name ellipsis">{{item.unit_name}}</div>
                            <router-link class="preview_btn"
                                            :to="'/chinese/inspect/preview/task/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                            <button class="share_btn"
                                    @click="share(item)">分享给学生</button>
                            <button class="go_detail"
                                    @click="goDetail(item)">查看完成情况</button>
                        </div>
                    </div>
                </div>
                <!-- 小学数学期末测试一 -->
                <div v-if="sx1.length"
                        class="item">
                    <div class="list_title"><span>数学</span>领跑新学期试卷一</div>
                    <div class="unit_list">
                        <div class="list_item"
                                v-for="(item,index) in sx1"
                                :key="index">
                            <div class="unit_name ellipsis">{{item.unit_name}}</div>
                            <router-link class="preview_btn"
                                            :to="'/preview/task/21/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                            <button class="share_btn"
                                    @click="share(item)">分享给学生</button>
                            <button class="go_detail"
                                    @click="goDetail(item)">查看完成情况</button>
                        </div>
                    </div>
                </div>
                <!-- 小学数学期末测试一 -->
                <div v-if="sx2.length"
                        class="item">
                    <div class="list_title"><span>数学</span>领跑新学期试卷二</div>
                    <div class="unit_list">
                        <div class="list_item"
                                v-for="(item,index) in sx2"
                                :key="index">
                            <div class="unit_name ellipsis">{{item.unit_name}}</div>
                            <router-link class="preview_btn"
                                            :to="'/preview/task/21/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                            <button class="share_btn"
                                    @click="share(item)">分享给学生</button>
                            <button class="go_detail"
                                    @click="goDetail(item)">查看完成情况</button>
                        </div>
                    </div>
                </div>
                <!-- 初中数学期末测试一a -->
                <div v-if="msx1.length"
                        class="item">
                    <div class="list_title long_title"><span>初中数学</span>领跑新学期试卷一</div>
                    <div class="unit_list">
                        <div class="list_item"
                                v-for="(item,index) in msx1"
                                :key="index">
                            <div class="unit_name ellipsis">{{item.unit_name}}</div>
                            <router-link class="preview_btn"
                                            :to="'/preview/task/21/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                            <button class="share_btn"
                                    @click="share(item)">分享给学生</button>
                            <button class="go_detail"
                                    @click="goDetail(item)">查看完成情况</button>
                        </div>
                    </div>
                </div>
                <!-- 初中数学期末测试二 -->
                <div v-if="msx2.length"
                        class="item">
                    <div class="list_title long_title"><span>初中数学</span>领跑新学期试卷二</div>
                    <div class="unit_list">
                        <div class="list_item"
                                v-for="(item,index) in msx2"
                                :key="index">
                            <div class="unit_name ellipsis">{{item.unit_name}}</div>
                            <router-link class="preview_btn"
                                            :to="'/preview/task/21/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                            <button class="share_btn"
                                    @click="share(item)">分享给学生</button>
                            <button class="go_detail"
                                    @click="goDetail(item)">查看完成情况</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import loadingS from 'SRC/components/base/loadingS.vue';
export default {
    components: {
        loadingS
    },
    data () {
        return {
            hd_type: 12,//本次活动type
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            loading: true,
            unitData: {},
            yw1: [],//语文试卷一
            yw2: [],//语文试卷二
            sx1: [],//小学数学试卷一
            sx2: [],//小学数学试卷二
            msx1: [],//初中小学数学试卷一
            msx2: [],//初中数学试卷二
        }
    },
    created () {
        this.$http.post(API_URL_HD_API + "/common/get_paper", {
            hd_type: this.hd_type
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.unitData = res.data
                res.data.yw_paper.forEach(e => {
                    if (e.sid == 51 && e.sequence == 1) {
                        this.yw1.push(e)
                    }
                    if (e.sid == 51 && e.sequence == 2) {
                        this.yw2.push(e)
                    }
                })
                res.data.sx_paper.forEach(e => {
                    if (e.dept_type == 1 && e.sequence == 1) {
                        this.sx1.push(e)
                    }
                    if (e.dept_type == 1 && e.sequence == 2) {
                        this.sx2.push(e)
                    }
                    if (e.dept_type == 2 && e.sequence == 1) {
                        this.msx1.push(e)
                    }
                    if (e.dept_type == 2 && e.sequence == 2) {
                        this.msx2.push(e)
                    }
                })
                if (this.yw1.length < 1 && this.yw2.length < 1 && this.sx1.length < 1 && this.sx2.length < 1 && this.msx1.length < 1 && this.msx2.length < 1) {
                    layer.alert('暂无试卷')
                }

            } else {
                layer.tips(res.message);
            }
        }).finally(() => { this.loading = false; })
    },
    methods: {
        goBack () {
            this.appFunction("ys_finish", "", 1);
        },
        share (unit) {
            let that = this
            let title = unit.school_name + (unit.sid == 21 ? "数学" : "语文") + "领跑新学期";
            let content = "点击参加" + (unit.sid == 21 ? "数学" : "语文") + "领跑新学期";
            if (this.inApp) {
                this.appFunction("ys_share", `${title},${content},${unit.wap_url},${String(unit.sid)[0]},${unit.unit_class_id},0,26,领跑新学期活动分享`);
            } else {
                layer.alert('在输入框中进行粘贴后，点击发送即可！', 'tea', function (index) {
                    that.copyText(`${title},${content},链接：${unit.wap_url}`)
                    layer.close(index)
                }, '分享链接复制成功')
            }

        },
        goDetail (u) {
            this.$store.commit('setTabtype', 1)
            this.$router.push(`/personaLearning?sid=${u.sid}&taskId=${u.paper_id}&classId=${u.unit_class_id}&hd_type=${this.hd_type}&dept_type=${u.dept_type}&className=${encodeURIComponent(u.unit_name)}`)
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
    },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #appIndex {
        min-height: 100vh;
        background-color: #1d9a65;
        .appIndex_banner {
            height: 1102px/$ppr;
            background-size: 100% 100%;
            background-image: url("./img/banner.jpg");
            .back_icon{
                position: absolute;
                width: 82px/$ppr;
                height: 97px/$ppr;
                background-position: center;
                background-size: 18px/$ppr 33px/$ppr;
                background-repeat: no-repeat;
                background-image: url("./img/img_icon_01.png");
                cursor: pointer;
                top: 40px/$ppr;
                left: 0;
            }
        }
        .subject_list {
            margin: -91px/$ppr auto 0;
            padding-bottom: 64px/$ppr;
            width: 672px/$ppr;
            position: relative;
            z-index: 3;
            .item {
                background-color: #fff;
                position: relative;
                padding: 96px/$ppr 36px/$ppr 36px/$ppr;
                border-radius: 20px/$ppr;
                box-shadow: 0 12px/$ppr 12px/$ppr 0 rgba(18, 130, 86, 0.2);
                &:not(:last-child){
                    margin-bottom: 64px/$ppr;
                }
                .list_title {
                    text-align: center;
                    height: 72px / $ppr;
                    line-height: 72px / $ppr;
                    font-size: 32px / $ppr;
                    color: #fff;
                    font-weight: bold;
                    position: relative;
                    width: 408px / $ppr;
                    position: absolute;
                    top: -9px/$ppr;
                    left: 50%;
                    margin-left: -204px/$ppr;
                    background-image: url("./img/img_icon_02.png");
                    background-size: 100% 100%;
                    &.long_title{
                        width: 464px / $ppr;
                        margin-left: -232px/$ppr;
                        background-image: url("./img/img_icon_03.png");
                    }
                    span {
                        color: #f9f51b;
                    }
                }
                .unit_list {
                    .list_item {
                        display: flex;
                        align-items: center;
                        background-color: #eff3fc;
                        border-radius: 12px / $ppr;
                        height: 130px / $ppr;
                        padding: 0 18px / $ppr;
                        overflow: hidden;
                        &:not(:last-child){
                            margin-bottom: 20px / $ppr;
                        }
                        .unit_name {
                            flex-grow: 1;
                            font-size: 28px / $ppr;
                            color: #333;
                            font-weight: bold;
                            padding-left: 18px / $ppr;
                        }
                        .preview_btn {
                            font-size: 28px / $ppr;
                            color: #3a6bca;
                            flex-shrink: 0;
                            padding-right: 28px / $ppr;
                        }
                        button {
                            height: 56px / $ppr;
                            border-radius: 28px / $ppr;
                            border: none;
                            color: #fff;
                            font-size: 24px / $ppr;
                            &.share_btn {
                                width: 156px / $ppr;
                                margin-right: 18px / $ppr;
                                background-color: #0263f3;
                            }
                            &.go_detail {
                                width: 170px / $ppr;
                                background-color: #e55360;
                            }
                        }
                    }
                }
            }
        }
    }
</style>